export default (selector) => {
  const tables = document.querySelectorAll(selector);

  if (tables.length === 0) {
    return;
  }

  tables.forEach((table) => {
    const { filter } = table.dataset;
    const filterInput = document.getElementById(filter);
    if (!filterInput) {
      console.error('No filter input found for table', table);
      return;
    }
    filterInput.oninput = () => {
      Array.prototype.forEach.call(table.tBodies, (tBody) => {
        Array.prototype.forEach.call(tBody.rows, (row) => {
          const text = row.textContent.toLowerCase();
          const val = filterInput.value.toLowerCase();
           
          row.style.display = text.indexOf(val) === -1 ? 'none' : 'table-row';
        });
      });
    };
  });
};
